export default __webpack_public_path__ + "static/media/iconAlerta.998a96cf.svg";